var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "header-middel left",
    class: {
      globalControl: _vm.$route.name == 'globalControl'
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTitle,
      expression: "showTitle"
    }]
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.mainWindow')) + ":")]), _c('el-select', {
    staticClass: "outputType",
    attrs: {
      "popper-class": "kiosk-mainwindow"
    },
    on: {
      "change": _vm.changeMainWindowType
    },
    model: {
      value: _vm.selectOutputType,
      callback: function ($$v) {
        _vm.selectOutputType = $$v;
      },
      expression: "selectOutputType"
    }
  }, _vm._l(_vm.mainWindowList, function (group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": _vm._f("showSourceType")(group.label)
      }
    }, _vm._l(group.options, function (item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": _vm.$route.name == 'coordinator' && item.value == 'pip' ? _vm.$t('kioskHost.Speaker') : _vm.$t(`kioskHost.${item.value}`),
          "value": item.value
        }
      }, [_c('span', [_vm._v(" " + _vm._s(_vm._f("showSourceType")(item.label)) + " "), _c('el-tooltip', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: item.label === 'VFB (Receiver Video Return)',
          expression: "item.label === 'VFB (Receiver Video Return)'"
        }],
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "content": _vm.$t('common.versionText'),
          "placement": "top"
        }
      }, [_c('i', {
        staticClass: "iconfont icon-help2"
      })]), _c('el-tooltip', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: item.label === 'Tag',
          expression: "item.label === 'Tag'"
        }],
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "content": _vm.$t('common.tagText'),
          "placement": "top"
        }
      }, [_c('i', {
        staticClass: "iconfont icon-help2"
      })])], 1)]);
    }), 1);
  }), 1), _c('el-divider', {
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "manual": true,
      "value": _vm.showTag,
      "content": _vm.$t('kioskHost.tagInput'),
      "placement": "top"
    }
  }, [_vm.selectOutputType != 'PBP' ? _c('el-select', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.listScroll,
      expression: "listScroll"
    }],
    ref: "selectBox",
    staticClass: "selectBox m_r_20",
    attrs: {
      "visible-arrow": false,
      "placeholder": _vm.returnPlaceholder,
      "no-data-text": _vm.returnNoData,
      "no-match-text": _vm.returnNoData,
      "filterable": "",
      "filter-method": val => {
        _vm.getOutputList('filter', '', val);
      },
      "disabled": _vm.showSelectBox || _vm.selectOutputType == 'Tag',
      "popper-class": _vm.returnClass
    },
    on: {
      "visible-change": val => {
        if (val) _vm.getOutputList('getReceiverList', 'visiable', val);
      }
    },
    nativeOn: {
      "mouseover": function ($event) {
        return _vm.showTagTooltip('enter');
      },
      "mouseout": function ($event) {
        return _vm.showTagTooltip('leave');
      }
    },
    model: {
      value: _vm.selectOutput,
      callback: function ($$v) {
        _vm.selectOutput = $$v;
      },
      expression: "selectOutput"
    }
  }, _vm._l(_vm.outputList, function (item) {
    return _c('el-option', {
      key: item.mainwindowId,
      attrs: {
        "label": _vm.nickNameInfo[item.mainwindowId] || item.name,
        "value": item.mainwindowId
      }
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.showVfbDialog(item);
        }
      }
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.nickNameInfo[item.mainwindowId] || item.name))]), item.email ? _c('p', {
      staticClass: "email"
    }, [item.email == _vm.State.loginInfo.email ? _c('span', [_vm._v("(" + _vm._s(_vm.$t('kioskHost.me')) + ")")]) : _vm._e(), _vm._v(_vm._s(item.email))]) : _vm._e()]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.selectOutputType === 'PP' && _vm.outputList.length == 0,
        expression: "selectOutputType === 'PP'&& outputList.length==0"
      }]
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.noProgram')))])])]);
  }), 1) : _vm._e()], 1), _vm.selectOutputType == 'PBP' ? _c('div', {
    staticClass: "pbpSelect"
  }, _vm._l(_vm.pbpList, function (val, index) {
    return _c('el-select', {
      key: index,
      staticClass: "selectBox m_r_20",
      class: {
        notFirstSource: index > 0
      },
      attrs: {
        "visible-arrow": false,
        "placeholder": _vm.$t(`kioskHost.${val.text}`),
        "no-data-text": "No Data",
        "no-match-text": "No Match Data",
        "filterable": "",
        "clearable": _vm.sendBtnColor == 'red' ? false : true
      },
      on: {
        "visible-change": _vm.getOutputList,
        "change": _vm.changeSourceItem
      },
      model: {
        value: val.rtilCode,
        callback: function ($$v) {
          _vm.$set(val, "rtilCode", $$v);
        },
        expression: "val.rtilCode"
      }
    }, _vm._l(val.outputList, function (item) {
      return _c('el-option', {
        key: item.mainwindowId,
        attrs: {
          "label": _vm.nickNameInfo[item.mainwindowId] || item.name,
          "value": item.mainwindowId
        }
      }, [_c('div', [_vm._v(_vm._s(_vm.nickNameInfo[item.mainwindowId] || item.name))])]);
    }), 1);
  }), 1) : _vm._e(), _vm._t("galleryPreviewBox"), _c('el-divider', {
    staticClass: "line",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-button', {
    staticClass: "outputBtn m_r_10",
    class: {
      grays: _vm.sendBtnColor == 'gray',
      'green-gradient': _vm.sendBtnColor == 'green',
      'red-gradient': _vm.sendBtnColor == 'red'
    },
    attrs: {
      "disabled": _vm.sendBtnColor == 'gray' || (_vm.sendBtnColor == 'red' && JSON.stringify(_vm.globalMainInfo) != '{}' ? true : false)
    },
    on: {
      "click": _vm.controlOutput
    }
  }, [_vm._v(" " + _vm._s(_vm.sendBtnColor == 'red' ? _vm.$t('galleryHost.stop') : _vm.$t('galleryHost.send')) + " ")]), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.applyAllTips'),
      "placement": "top"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$route.name === 'globalControl',
      expression: "$route.name === 'globalControl'"
    }],
    staticClass: "applyAll",
    attrs: {
      "disabled": !_vm.selectOutput && _vm.selectOutputType != 'Tag' || _vm.selectOutputType == 'Tag' && _vm.sendBtnColor == 'green'
    },
    on: {
      "click": _vm.sendApplyAll
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.applyAll')) + " ")])], 1), _vm.sourceVfbType.show ? _c('select-source-type', {
    attrs: {
      "info": _vm.sourceVfbType,
      "sendReceiverInfo": _vm.sendReceiverInfo,
      "loadingBtn": _vm.liveLoading,
      "appendToBody": true,
      "showAudioHtml": true,
      "pageNum": _vm.pageNum
    },
    on: {
      "updateVfbData": _vm.updateVfbData,
      "updateTagStage": _vm.updateTagStage
    }
  }) : _vm._e(), _vm.encoderInfo.visible ? _c('EncoderInfo', {
    attrs: {
      "info": _vm.encoderInfo,
      "appendToBody": true
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };